import type { ViewStyle } from "react-native";

import { spacing } from "./tokens";

/** Shared reading widths for the main Web surfaces. Native can reuse these safely. */
export const contentMaxWidths = {
  feed: 760,
  search: 840,
  profile: 880,
  group: 880,
  create: 760,
  settings: 720,
  post: 760,
  dialog: 440,
  control: 1120,
} as const;

/** Common centered page wrapper used by scrollable operational surfaces. */
export function contentPage(maxWidth: number): ViewStyle {
  return {
    alignSelf: "center",
    boxSizing: "border-box",
    maxWidth,
    padding: spacing.xl,
    width: "100%",
  };
}

/** Constrain the CONTENT, never the scroll viewport: its scrollbar stays at the window edge. */
export function readingContent(maxWidth: number): ViewStyle {
  return { alignSelf: "center", boxSizing: "border-box", width: "100%", maxWidth, minWidth: 0 };
}
